var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 546 546",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 197 231 C 184 243 184 264 195 280 194 280 194 281 193 282 L 72 390 C 65 396 63 406 66 416 65 417 63 418 62 419 L 32 445 C 20 455 21 476 33 490 46 504 67 506 79 495 L 107 470 C 109 469 110 467 111 465 120 469 130 468 137 462 L 257 354 C 258 353 259 352 260 352 274 365 295 367 308 355 L 505 178 C 519 165 518 141 504 125 L 498 119 514 105 C 526 94 525 74 513 60 500 46 480 43 468 54 L 452 68 446 60 C 431 44 408 41 394 54 L 197 231 Z M 482 59 C 492 55 504 61 509 71 514 82 510 94 501 97 491 101 479 96 473 85 468 74 472 63 482 59 Z M 45 450 C 55 446 68 452 74 463 79 473 75 485 65 489 54 493 42 487 37 476 32 466 36 454 45 450 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShock);
export default __webpack_public_path__ + "static/media/shock.422b591791511472baaad4d4a0c467c5.svg";
export { ForwardRef as ReactComponent };